export default __webpack_public_path__ + "static/img-slider-01-7880f4f9f21da3938d10962977dab44c.png";